import { render, staticRenderFns } from "./TraxUiSidebarToggle.vue?vue&type=template&id=5291d408"
import script from "./TraxUiSidebarToggle.vue?vue&type=script&lang=js"
export * from "./TraxUiSidebarToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports